import {
  DocumentNode,
  FetchPolicy,
  MutationHookOptions,
  MutationOptions,
  OperationVariables,
  QueryHookOptions,
  QueryOptions,
  TypedDocumentNode,
  useLazyQuery,
  useMutation,
  useQuery,
} from '@apollo/client'
import { ApolloClientInstance } from './Provider'

export const ONE_MINUTE = 1000 * 60

export const getFetchPolicyForNamedQuery = (
  key: string,
  expirationMs: number,
  forceRefetch?: boolean
): FetchPolicy => {
  // const cache = useQueryCache.getState()
  // const nextFetchTime = cache.queries[key] || 0

  const fetchPolicy: FetchPolicy = 'cache-first'

  // Is Expired?
  // if (forceRefetch || Date.now() >= nextFetchTime) {
  //   useQueryCache.getState().cache(key, Date.now() + expirationMs)
  //   fetchPolicy = 'network-only'
  // }
  return fetchPolicy
}

export const createGqlMutateOperation = <
  Res extends any,
  Vars extends OperationVariables
>(
  mutation: DocumentNode | TypedDocumentNode<Res, Vars>,
  defaultOptions?: Partial<Omit<MutationOptions<Res, Vars>, 'mutation'>>
) => {
  return {
    mutation,
    useMutation: (options: MutationHookOptions<Res, Vars>) =>
      useMutation(mutation, {
        ...(defaultOptions || {}),
        ...options,
      }),
    execute: async (options: Omit<MutationOptions<Res, Vars>, 'mutation'>) => {
      const client = ApolloClientInstance.getInstance()
      const data = await client.mutate<Res, Vars>({
        ...defaultOptions,
        ...options,
        mutation,
      })
      return data
    },
  }
}

export const createGqlQueryOperation = <
  Res extends any,
  Vars extends OperationVariables
>(
  query: DocumentNode | TypedDocumentNode<Res, Vars>,
  opts?: {
    cache?: {
      key: string
      expirationMs: number
      forceRefetch?: boolean
    }
  }
) => {
  const getFetchPolicy = () => {
    return opts?.cache && typeof window !== 'undefined'
      ? getFetchPolicyForNamedQuery(
        opts.cache.key,
        opts.cache.expirationMs,
        opts.cache.forceRefetch
      )
      : undefined
  }

  return {
    query,
    getFetchPolicy,
    useQuery: (options: QueryHookOptions<Res, Vars>) =>
      useQuery(query, {
        fetchPolicy: getFetchPolicy(),
        ...options,
      }),

    useLazyQuery: (options: QueryHookOptions<Res, Vars>) =>
      useLazyQuery(query, {
        fetchPolicy: getFetchPolicy(),
        ...options,
      }),
    execute: async (options: Omit<QueryOptions<Vars, Res>, 'query'>) => {
      const client = ApolloClientInstance.getInstance()
      const data = await client.query<Res, Vars>({
        fetchPolicy: getFetchPolicy(),
        ...options,
        query,
      })
      return data
    },
  }
}
